import { Tag, Tooltip } from "antd";
import { FaCheckCircle, FaClock, FaExclamationCircle, FaTimesCircle } from "react-icons/fa";

import { ECityTaxStatus } from "../../../../enums";

interface IProps {
    status: ECityTaxStatus,
    message?: string,
}

export default function StatusTag({ status, message }: IProps) {
let color = "#999";
  let icon = null;
  let tooltipText = "";

  switch (status) {
    case ECityTaxStatus.approved:
      color = "#52c41a";
      icon = <FaCheckCircle />;
      break;
    case ECityTaxStatus.error:
      color = "#ff4d4f";
      icon = <FaTimesCircle />;
      tooltipText = message && message !== "Recusado" ? message : "Recusado";
      break;
    case ECityTaxStatus.warning:
      color = "#faad14";
      icon = <FaExclamationCircle />;
      tooltipText = message && message !== "Alerta" ? message : "Alerta";
      break;
    case ECityTaxStatus.processing:
      color = "#1890ff";
      icon = <FaClock />;
      tooltipText = "Em análise";
      break;
    default:
      color = "#999";
      icon = null;
  }

  const statusText =
    status === ECityTaxStatus.error ? "Recusado" : status;

  const tagElement = (
    <Tag
      style={{
        backgroundColor: color + "20",
        color: color,
        fontWeight: 600,
        borderRadius: 16,
        border: `1px solid ${color + "40"}`,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        gap: 6,
      }}
    >
      {icon}
      {statusText}
    </Tag>
  );

  return tooltipText ? (
    <Tooltip title={tooltipText} color={color}>
      {tagElement}
    </Tooltip>
  ) : (
    tagElement
  );
}
